import React from 'react';

import './css/styles.css';

class PanelLaUnidadQueSomos extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            comoLoHacemos: {},
            queHacemos: {},
            queSomos: {},
        }
    }

    componentWillMount(){
        
        fetch('/api/uip/unidad/como/lo/hacemos', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => { this.setState({ comoLoHacemos: response[0]})})
            .catch(response => console.log(response))

        fetch('/api/uip/unidad/que/hacemos', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => { this.setState({ queHacemos: response[0]})})
                .catch(response => console.log(response))

        fetch('/api/uip/unidad/que/somos', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(response => { this.setState({ queSomos: response[0]})})
                    .catch(response => console.log(response))
    }

    render(){
        return(
            <div className="container_unidad">
                <div className="row">
                    <div className="container_unidad_section">
                        <div className="container_unidad_titulo_left">
                            <span className="texto_titulo_unidad">Que Somos</span>
                            <img src={this.state.queSomos.imagen1} />
                        </div>
                        <div className="container_unidad_titulo_right">
                            <span className="texto_titulo_unidad">Que Somos</span>
                            <img src={this.state.queSomos.imagen2} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="container_unidad_section">
                        <div className="container_unidad_titulo_medio_left">
                            <span className="texto_titulo_unidad">Que Hacemos</span>
                            <img src={this.state.queHacemos.imagen1} />
                        </div>
                        <div className="container_unidad_titulo_medio_right">
                            <span className="texto_titulo_unidad">Que Hacemos</span>
                            <img src={this.state.queHacemos.imagen2} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="container_unidad_section">
                        <div className="container_unidad_titulo_left">
                            <span className="texto_titulo_unidad">Como lo Hacemos</span>
                            <img src={this.state.comoLoHacemos.imagen1} />
                        </div>
                        <div className="container_unidad_titulo_right">
                            <span className="texto_titulo_unidad">Como lo Hacemos</span>
                            <img src={this.state.comoLoHacemos.imagen2} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PanelLaUnidadQueSomos;